export default {
  add_popup: 'Add',
};
